module.exports = __webpack_public_path__ + "img/gallery-image-10.1dbff352.jpg";